export class ClaimModel {
  claim?: any;
  subscription?: any;
  claimEvent?: any;
  paperAndDocument?: any;
  benefit?: any;
  claimCriteria?: any;
}

export interface IClaimDocs {
  contact?: any;
  listDocs?: any[];
  clientNumber?: number;
  claimNumber?: string;
  description?: string;
  motif?: string;
  subscriptionNumber?: string;
  applicationCode?: string;
  task?: boolean;
  ksl?: boolean;
}

export interface IEvent{
  eventType?: any;
  eventDate?: Date;
  eventShowDate?: Date;
  eventVariablePart?: string;
  businessEntityType?: number;
  businessEntityId?: string;

} 

